import React from 'react';
import { Button } from '@/app/components/ui/button';
import { useLanguage } from '@/app/contexts/LanguageContext';

export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-2 bg-slate-100 rounded-full p-1 border border-slate-200">
      <Button
        variant="ghost"
        size="sm"
        className={`rounded-full px-3 h-8 text-sm font-medium transition-all ${
          language === 'de' 
            ? 'bg-white text-purple-700 shadow-sm' 
            : 'text-slate-500 hover:text-slate-900'
        }`}
        onClick={() => setLanguage('de')}
      >
        <span className="mr-1.5">🇩🇪</span> DE
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className={`rounded-full px-3 h-8 text-sm font-medium transition-all ${
          language === 'en' 
            ? 'bg-white text-purple-700 shadow-sm' 
            : 'text-slate-500 hover:text-slate-900'
        }`}
        onClick={() => setLanguage('en')}
      >
        <span className="mr-1.5">🇬🇧</span> EN
      </Button>
    </div>
  );
}
